/* Lifts the minimised Alia teaser ("Get 20% off"), or the in-house popup's .zp-pill, above whichever sticky add-to-cart
   bar is showing at the bottom of the screen, so the two never overlap.
   Sticky bars in this theme: .sticky-atc (default PDP), .zorali-sticky-bar
   (Overland / Air-Grid / Daylight accessories), .drd-mbar (Daylight R&D PDP).
   The CSS rule lives in custom.css and only targets the teaser state
   (Alia sets "bottom: 16px" inline on the teaser, "inset: 0px" on the full popup). */
(function () {
  var SEL = '.sticky-atc, .zorali-sticky-bar, .drd-mbar';
  var root = document.documentElement;
  var queued = false;

  function measure() {
    queued = false;
    var vh = window.innerHeight;
    var lift = 0;
    var bars = document.querySelectorAll(SEL);
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i];
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var r = el.getBoundingClientRect();
      if (r.height < 20 || r.top >= vh - 4 || r.bottom < vh - 8) continue; // not docked at the bottom
      lift = Math.max(lift, Math.round(vh - r.top));
    }
    root.style.setProperty('--zr-sticky-lift', lift + 'px');
    root.classList.toggle('zr-sticky-on', lift > 0);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(measure);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  // bars slide in with a transition; measure again once it has settled
  window.addEventListener('scroll', function () { setTimeout(queue, 350); }, { passive: true });
  document.addEventListener('DOMContentLoaded', queue);
  window.addEventListener('load', queue);
  new MutationObserver(queue).observe(document.body || root, {
    subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
  });
})();
